import { FC } from 'react';

type PropsType = {
    src: string;
    alt?: string;
    onClick?: () => void;
    className?: string;
    onLoad?: () => void;
    onError?: () => void;
    ref?: React.Ref<HTMLImageElement>;
    style?: React.CSSProperties;
};

const Image: FC<PropsType> = (props) => {
    return <img {...props} />;
};

export default Image;
